import { createContext, useContext } from "react";

import { LanguageType } from "@/translations";

import { LanguageContextValue } from "./LanguageContextProvider.types.ts";

const defaultValue: LanguageContextValue = {
  language: LanguageType.de,
  setLanguage: () => {},
};

export const LanguageContext = createContext(defaultValue);
export const useLanguageContext = (): LanguageContextValue => useContext(LanguageContext);
